import React from 'react';
import { List, Typography } from 'antd';
import {thousands} from '../../utils'
import ReactEcharts from 'echarts-for-react'
const CreatePieChart = (option) => {
  return {
    title: {
        text: '热门栏目',
        subtext: '栏目信息',
        left: 'center'
    },
    tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)'
    },
    legend: {
        left: 'center',
        top: '10%',
        data: option.data
    },
    series: [
      {
        name: '访问来源',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 2
        },
        label: {
            show: false,
            position: 'center'
        },
        emphasis: {
            label: {
                show: true,
                fontSize: '18',
                fontWeight: 'bold'
            }
        },
        labelLine: {
            show: false
        },
        data:option.data
    }
    ]
};
  
}
const VillageList = (props) => {
  let {villages} = props
  console.log(villages);
  const tempArr = []
  for(let item of villages ){
    tempArr.push({value:item.clickcount,name:item.title})
  }
  const option = CreatePieChart({data:tempArr})
  return (
    <div className="VillageList">
      <ReactEcharts option={option} className='echarts-for-echarts' style={{
            width:'400px',
            height: '600px'
          }}></ReactEcharts>
      {/* <List
        header={<div>热门景区</div>}
        bordered
        dataSource={villages}
        renderItem={item => (
          <List.Item>
            {item.title}
        <div className="views">{thousands(item.clickcount)}</div>
          </List.Item>
        )}
      /> */}
    </div>
  );
};

export default VillageList;